import { render, staticRenderFns } from "./Regras.vue?vue&type=template&id=b51cb090&scoped=true&"
import script from "./Regras.vue?vue&type=script&lang=js&"
export * from "./Regras.vue?vue&type=script&lang=js&"
import style0 from "./Regras.vue?vue&type=style&index=0&id=b51cb090&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51cb090",
  null
  
)

export default component.exports